export const sortRows = (rows: any[], descending: boolean, sortBy: string) =>
  [...rows].sort((a, b) => {
    if (a.isNew && !b.isNew) return -1;
    if (!a.isNew && b.isNew) return 1;

    const valA = a[sortBy];
    const valB = b[sortBy];

    if (valA === valB) return 0;

    const compareA = typeof valA === 'string' ? valA.toLowerCase() : valA;
    const compareB = typeof valB === 'string' ? valB.toLowerCase() : valB;

    return (compareA > compareB ? 1 : -1) * (descending ? -1 : 1);
  });

export const sliceRows = (rows: any[], page: number, itemsPerPage: number) =>
  rows.slice(itemsPerPage * (page - 1), itemsPerPage * page);
